import type { CPU } from '../CPU';
import { PSW_C, PSW_Z, PSW_OV, PSW_HC } from './constants';
import { add8, zsCheck } from './arithmetic';

export function opDAA(cpu: CPU): void {
  cpu.impl_operands[1].value = 0;
  if ((cpu.impl_operands[0].value & 0x0F) > 0x09 || (cpu.impl_flags_in & PSW_HC))
    cpu.impl_operands[1].value |= 0x06;
  if ((cpu.impl_operands[0].value & 0xF0) > 0x90 || (cpu.impl_flags_in & PSW_C))
    cpu.impl_operands[1].value |= 0x60;
  if ((cpu.impl_operands[0].value & 0xF0) === 0x90 && (cpu.impl_operands[0].value & 0x0F) > 0x09 && !(cpu.impl_flags_in & PSW_HC))
    cpu.impl_operands[1].value |= 0x60;

  const flags_in_backup = cpu.impl_flags_in;
  cpu.impl_flags_in &= ~PSW_C;
  cpu.impl_flags_in |= PSW_Z;
  add8(cpu);
  if (!(cpu.impl_flags_in & PSW_Z))
    cpu.impl_flags_out &= ~PSW_Z;
  zsCheck(cpu);
  cpu.impl_flags_out |= flags_in_backup & PSW_C;
  cpu.impl_flags_changed &= ~PSW_OV;
}

export function opDAS(cpu: CPU): void {
  cpu.impl_operands[1].value = 0;
  if ((cpu.impl_operands[0].value & 0x0F) > 0x09 || (cpu.impl_flags_in & PSW_HC))
    cpu.impl_operands[1].value |= 0x06;
  if ((cpu.impl_operands[0].value & 0xF0) > 0x90 || (cpu.impl_flags_in & PSW_C))
    cpu.impl_operands[1].value |= 0x60;
  const flags_in_backup = cpu.impl_flags_in;
  cpu.impl_flags_in &= ~PSW_C;
  cpu.impl_flags_in |= PSW_Z;
  cpu.impl_operands[0].value ^= 0xFF;
  add8(cpu);
  cpu.impl_operands[0].value ^= 0xFF;
  if (!(cpu.impl_flags_in & PSW_Z))
    cpu.impl_flags_out &= ~PSW_Z;
  zsCheck(cpu);
  cpu.impl_flags_out |= flags_in_backup & PSW_C;
  cpu.impl_flags_changed &= ~PSW_OV;
}

export function opNEG(cpu: CPU): void {
  cpu.impl_operands[1].value = cpu.impl_operands[0].value;
  cpu.impl_operands[0].value = 0;
  cpu.impl_flags_in &= ~PSW_C;
  cpu.impl_flags_in |= PSW_Z;
  cpu.impl_operands[0].value ^= 0xFF;
  add8(cpu);
  cpu.impl_operands[0].value ^= 0xFF;
  if (!(cpu.impl_flags_in & PSW_Z))
    cpu.impl_flags_out &= ~PSW_Z;
  zsCheck(cpu);
}

export function opEXTBW(cpu: CPU): void {
  const index = (cpu.impl_opcode & 0x00E0) >> 4;
  cpu.impl_operands[0].value = (cpu.regs.r[index] & 0x80) ? 0xFF : 0x00;
  cpu.regs.r[index + 1] = cpu.impl_operands[0].value;
  zsCheck(cpu);
}
